<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <b-form
                @submit.prevent="validateForm('form-1')"
                data-vv-scope="form-1">
                    <hr/>
                    <h6 class="mt-4"><b>Driver Info</b></h6>
                    <br />
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="first name">Driver First Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input
                                type="text"
                                name="first name"
                                v-model="customer.driverfirstname"
                                v-validate="'required|alpha|min:3|max:30'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.first name'),
                                }"
                                placeholder="Enter First Name"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('first name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.first name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.first name") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="last name">Driver Last Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    name="last name"
                                    v-model="customer.driverlastname"
                                    v-validate="'required|alpha|min:3|max:30'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.last name'),
                                    }"
                                    placeholder="Enter Last Name"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('last name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.last name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.last name") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="addmobilenumber">Driver Mobile No</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    id="addmobilenumber"
                                    name="mobile number"
                                    maxlength="10"
                                    v-model="customer.drivermobilenumber"
                                    v-validate="'required|digits:10'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.mobile number'),
                                    }"
                                    placeholder="Enter Mobile Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('mobile number')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.mobile number')"
                                    id="addmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.mobile number") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="addaltenatemobilenumber">Alternate Mobile No</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    id="addaltenatemobilenumber"
                                    name="alternate_mobile number"
                                    maxlength="10"
                                    v-model="customer.driveraltmobilenumber"
                                    v-validate="'required|digits:10'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has(
                                        'form-1.alternate_mobile number'
                                    ),
                                    }"
                                    placeholder="Enter Alternate Mobile Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('alternate_mobile number')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.alternate_mobile number')"
                                    id="addaltmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.alternate_mobile number") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="drivinglicense">Driving License</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.drivinglicense"
                                    name="drivinglicense"
                                    id="drivinglicense"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.drivinglicense'),
                                    }"
                                    placeholder="Enter Driving License"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.drivinglicense')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.drivinglicense") }} 'Please
                                    enter letters only'</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="password">Password</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="password"
                                    name="password"
                                    minlength="6"
                                    maxlength="14"
                                    v-model="customer.password"
                                    v-validate="'required|min:6|max:14'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.password'),
                                    }"
                                    placeholder="Enter Password"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('password')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.password')"
                                    id="passwordtxt"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.password") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="4" v-if="userType == 1">
                            <label>Select Admin</label>&nbsp;<span style="color: red;">*</span>
                            <div id="container">
                                <ejs-multiselect
                                id="multi_select"
                                placeholder="Select Admin"
                                v-model="valueAdmin"
                                @change="selectAdmin"
                                :dataSource="optionsAdmin"
                                :showSelectAll="showSelectAll"
                                selectAllText="Select All"
                                unSelectAllText="unSelect All"
                                :fields="fieldAdmin"
                                :allowCustomValue="allowCustomValue"
                                enableGroupCheckBox="true"
                                mode="CheckBox"
                                ></ejs-multiselect>
                            </div>
                        </b-col>

                        <b-col sm="4" v-if="userType == 1">
                            <div id="container" v-if="valueAdmin.length>0">
                                <label>Select City</label>&nbsp;<span style="color: red;">*</span>
                                <ejs-multiselect
                                id="multi_select"
                                placeholder="Select City"
                                v-model="valueWHAdmin"
                                @change="selectWHAdmin"
                                :dataSource="warehouseAdmin"
                                :showSelectAll="showSelectAll"
                                selectAllText="Select All"
                                unSelectAllText="unSelect All"
                                :fields="fieldwhAdmin"
                                :allowCustomValue="allowCustomValue"
                                enableGroupCheckBox="true"
                                mode="CheckBox"
                                ></ejs-multiselect>
                            </div>
                        </b-col>

                        <b-col sm="4" v-if="userType == 2">
                            <label>Select City</label>&nbsp;<span style="color: red;">*</span>
                            <div id="container">
                                <ejs-multiselect
                                id="multi_select"
                                placeholder="Select City"
                                v-model="valueWHAdmin"
                                @change="selectWHAdmin"
                                :dataSource="warehouseAdmin"
                                :showSelectAll="showSelectAll"
                                selectAllText="Select All"
                                unSelectAllText="unSelect All"
                                :fields="fieldwhAdmin"
                                :allowCustomValue="allowCustomValue"
                                enableGroupCheckBox="true"
                                mode="CheckBox"
                                ></ejs-multiselect>
                            </div>
                        </b-col>

                        <b-col sm="4" v-if="userType == 1 && valueWHAdmin.length>0">
                            <b-form-group>
                            <label for="hub_name">Select Hub</label>&nbsp;<span style="color: red;">*</span>
                                <v-select v-model="adminHub" :options="optionHubid" placeholder="-- Select Hub --"></v-select>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.hub_name')"
                                    class="help text-danger"
                                    >{{errors.first("form-1.hub_name")}}</span
                                >
                                </b-input-group>
                                
                            </b-form-group>
                        </b-col>
                        
                    </b-row>
                    <hr />
                    <br />

                    <h6><b>Helper Info</b></h6>
                    <br />
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="helperfirstname">Helper First Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input
                                type="text"
                                name="helperfirstname"
                                v-model="customer.helperfirstname"
                                v-validate="'required|alpha|min:3|max:30'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.helperfirstname'),
                                }"
                                placeholder="Enter First Name"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('helperfirstname')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.helperfirstname')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.helperfirstname") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="lastname">Helper Last Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    name="lastname"
                                    v-model="customer.helperlastname"
                                    v-validate="'required|alpha|min:3|max:30'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.lastname'),
                                    }"
                                    placeholder="Enter Last Name"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('lastname')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.lastname')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.lastname") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="mobilenumber">Helper Mobile No</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    id="addmobilenumber"
                                    name="mobilenumber"
                                    maxlength="10"
                                    v-model="customer.helpermobilenumber"
                                    v-validate="'required|digits:10'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.mobilenumber'),
                                    }"
                                    placeholder="Enter Mobile Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('mobilenumber')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.mobilenumber')"
                                    id="addmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.mobilenumber") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="alternatemobile">Alternate Mobile No</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    id="addaltenatemobilenumber"
                                    name="alternatemobile number"
                                    maxlength="10"
                                    v-model="customer.helperaltmobilenumber"
                                    v-validate="'required|digits:10'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has(
                                        'form-1.alternatemobile number'
                                    ),
                                    }"
                                    placeholder="Enter Alternate Mobile Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('alternatemobile number')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.alternatemobile')"
                                    id="addaltmblnbrmsg"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.alternatemobile number") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr />
                    <br />

                    <h6><b>Vehicle Info</b></h6>
                    <br />
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="vehicleno ">Vehicle Number</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehicleno"
                                    name="vehicleno"
                                    id="vehicleno"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicleno'),
                                    }"
                                    placeholder="Enter Vehicle Number"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    v-show="errors.has('form-1.vehicleno')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehicleno") }} 
                                </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <!-- <b-form-group>
                                <label for="vehicle name">Vehicle Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input
                                type="text"
                                name="vehicle name"
                                v-model="customer.vehiclename"
                                v-validate="'required|min:3|max:30'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicle name'),
                                }"
                                placeholder="Enter Vehicle Name"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('vehicle name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicle name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehicle name") }}</span
                                >
                                </b-input-group>
                            </b-form-group> -->
                            <b-form-group>
                                <label for="vehiclename">Vehicle Name</label>&nbsp;<span style="color: red;">*</span>
                                    <v-select v-model="customer.vehiclename" name="vehiclename" :options="vehicleNameOptions" @input="addVehicleName" placeholder="-- Select Vehicle Name --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehiclename'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.vehiclename')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.vehiclename")
                                        }}</span
                                    >
                                    </b-input-group>                               
                            </b-form-group>
                        </b-col>

                        <b-col sm="3" v-if="vehiclenametext">
                            <b-form-group>
                                <label for="vehicle name">Vehicle Name</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input
                                type="text"
                                name="vehicle name"
                                v-model="customer.vehiclenametext"
                                v-validate="'required|min:3|max:30'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicle name'),
                                }"
                                placeholder="Enter Vehicle Name"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('vehicle name')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicle name')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehicle name") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        
                        <b-col sm="3">
                            <b-form-group>
                            <label for="registration_no ">Registration certificate No</label>&nbsp;<span style="color: red;">*</span>
                            <b-input-group class="mb-3">
                                <b-form-input
                                class="input"
                                type="text"
                                v-model="customer.registration_no"
                                name="registration_no"
                                id="registration_no"
                                v-validate="'required'"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.registration_no'),
                                }"
                                placeholder="Enter Registration certificate No"
                                >
                                </b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span
                                v-show="errors.has('form-1.registration_no')"
                                class="help text-danger"
                                >{{ errors.first("form-1.registration_no") }} 
                                </span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="movementtype">Movement Type</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-select
                                    v-model="customer.vehicletype"
                                    name="movementtype"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.movementtype'),
                                    }"
                                >
                                    <option :value="selected_type">--Select--</option>
                                    <option value="inter">Inter City</option>
                                    <option value="intra">Intra City</option>
                                </b-form-select>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('movementtype')"
                                    ></i>
                                </span>
                                <code
                                    v-show="errors.has('form-1.movementtype')"
                                    id="statustxt"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.movementtype") }}
                                </code>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <!-- <b-col sm="3">
                            <b-form-group>
                                <label for="vehiclemake">Vehicle Make Type</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehiclemake"
                                    name="vehiclemake"
                                    id="vehiclemake"
                                    v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehiclemake'),
                                    }"
                                    placeholder="Enter Vehicle Make Type"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehiclemake')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehiclemake") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col> -->
                        <b-col sm="3">
                            <b-form-group>
                                <label for="vehicletypesize">Vehicle Type</label>&nbsp;<span style="color: red;">*</span>
                                    <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicletypesize'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.vehicletypesize')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.vehicletypesize")
                                        }}</span
                                    >
                                    </b-input-group>                               
                            </b-form-group>
                            
                        </b-col>

                        <b-col sm="3" v-if="vehicletypesizetext">
                            <b-form-group>
                                <label for="vehicle_type_size">Vehicle Type</label>&nbsp;<span style="color: red;">*</span>
                                <b-form-input
                                type="text"
                                name="vehicle_type_size"
                                v-validate="'required'"
                                v-model="customer.vehicletypesizetext"
                                :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.vehicle_type_size'),
                                }"
                                placeholder="Enter Vehicle Type"
                                >
                                </b-form-input>
                                <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                    <i
                                    class="fa fa-warning"
                                    v-show="errors.has('vehicle_type_size')"
                                    ></i>
                                </span>
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicle_type_size')"
                                    class="help text-danger"
                                    >{{ errors.first("form-1.vehicle_type_size") }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="vehicleweightcarrying">Vehicle Volumetric Weight (in Kg)</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehicleweightcarrying"
                                    name="vehicleweightcarrying"
                                    id="vehicleweightcarrying"
                                    v-validate="'required|decimal:3'"
                                    :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.vehicleweightcarrying'),
                                        }"
                                    placeholder="Enter Volumetric Weight"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicleweightcarrying')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-1.vehicleweightcarrying")
                                    }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="vehiclephysicalweight">Vehicle Physical Weight (in Kg)</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehiclephysicalweight"
                                    name="vehiclephysicalweight"
                                    id="vehiclephysicalweight"
                                    v-validate="'required|decimal:3'"
                                    :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.vehiclephysicalweight'),
                                        }"
                                    placeholder="Enter Physical Weight"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehiclephysicalweight')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-1.vehiclephysicalweight")
                                    }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="vehicledimensionsweight">Vehicle Dimensions Weight (in fit)</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehicledimensionsweight"
                                    name="vehicledimensionsweight"
                                    id="vehicledimensionsweight"
                                    v-validate="'required|decimal:3'"
                                    :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.vehicledimensionsweight'),
                                        }"
                                    placeholder="Enter Dimensions Weight"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicledimensionsweight')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-1.vehicledimensionsweight")
                                    }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col sm="3">
                            <b-form-group>
                                <label for="fueltype">Fuel Type</label>&nbsp;<span style="color: red;">*</span>
                                    <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                    :class="{
                                    input: true,
                                    'is-invalid': errors.has('form-1.fueltype'),
                                    }"></v-select>
                                    <b-input-group class="mb-3">
                                    <span
                                        style="width:240px"
                                        v-show="errors.has('form-1.fueltype')"
                                        class="help text-danger"
                                        >{{
                                        errors.first("form-1.fueltype")
                                        }}</span
                                    >
                                    </b-input-group>                               
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr />
                    <br />
                    <h6><b>Transporter Info</b></h6>
                    <b-button size="sm" @click="addemailid_fileds()">{{ searchableField ? 'Add New' : 'Select Existing' }}</b-button>
                    <br />
                   <div>
                    
                    <b-row v-if="searchableField">
                        <b-col sm="4"> 
                            <b-form-group>
                            <label for="transporterCompanyName">Transporter Company</label>&nbsp;<span style="color: red;">*</span>
                                <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --"></v-select>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.transporterCompanyName')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-1.transporterCompanyName")
                                    }}</span
                                >
                                </b-input-group>
                                
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                            <label for="transporetremail">Transporter Email</label>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.contracteremail" name="contracteremail" id="contracteremail"   placeholder="Enter Transporter Email" disabled></b-form-input>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                            <label for="transportername"> Transporter Name</label>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.drivercontractername" name="transportername" id="transportername"  placeholder="Enter Owner Name" disabled></b-form-input>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                            <label for="mobileno">Transporter Mobile No</label>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="mobileno" name="mobile number" maxlength="10" v-model="customer.contractormobilenumber" disabled placeholder="Enter Mobile No" ></b-form-input>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                            <label for="mobileno">Transporter Tin Number / GST Number</label>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="mobileno" name="mobile number" maxlength="10" v-model="customer.transporter_gstnumber" disabled placeholder="Enter Tin Number / GST Number" ></b-form-input>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row v-else>
                        <b-col sm="3" >
                            <b-form-group>
                            <label for="companyname">Transporter Company Name</label>&nbsp;<span style="color: red;">*</span>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="transporterCompanyName" name="companyname" id="companyname" v-validate="'required|min:3|max:50'" :class="{
                                input: true,'is-invalid': errors.has('form-1.companyname'),}" placeholder="Enter Transporter Company Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.companyname')" class="help text-danger">{{ errors.first("form-1.companyname") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" >
                            <b-form-group>
                            <label for="transporteremail">Transporter Email</label>&nbsp;<span style="color: red;">*</span>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.contracteremail" name="transporteremail" id="transporteremail" v-validate="'required|email'" :class="{input: true,'is-invalid': errors.has('form-1.transporteremail'),}" placeholder="Enter Transporter Email"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.transporteremail')" class="help text-danger">{{ errors.first("form-1.transporteremail") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                            <label for="transportername"> Transporter Name</label>&nbsp;<span style="color: red;">*</span>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" v-model="customer.drivercontractername" name="transportername" id="transportername" v-validate="'required|alpha_spaces'" :class="{
                                    input: true,'is-invalid': errors.has( 'form-1.transportername'),}" placeholder="Enter Transporter Name"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span style="width:240px" v-show="errors.has('form-1.transportername')" class="help text-danger">{{ errors.first("form-1.transportername") }}</span>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                            <label for="transportermobilenumber">Transporter Mobile No</label>&nbsp;<span style="color: red;">*</span>
                            <b-input-group class="mb-3">
                                <b-form-input class="input" type="text" id="transportermobilenumber" name="transportermobilenumber" maxlength="10" v-model="customer.contractormobilenumber" v-validate="'required|digits:10'" :class="{
                                    input: true,'is-invalid': errors.has('form-1.transportermobilenumber'),}" placeholder="Enter Mobile Number"></b-form-input>
                            </b-input-group>
                            <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('transportermobilenumber')"></i>
                                </span>
                                <code v-show="errors.has('form-1.transportermobilenumber')" id="addmblnbrmsg" class="help text-danger">{{ errors.first("form-1.mobile number") }}
                                </code>
                            </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="transportermobilenumber">Tin Number / GST Number</label>
                                <b-form-input name="GST Number" type="text"
                                    v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" 
                                    placeholder="Enter Tin Number / GST Number"
                                    :class="{ input: true, 'is-invalid': errors_GST,
                                    }">
                                </b-form-input>
                                <b-input-group class="mb-3">
                                  <span class="icon has-text-warning" v-if="errors_GST">
                                        <i
                                        class="fa fa-warning help text-danger"
                                        >{{ errors_showGST.transporter_gstnumber }}</i
                                        >
                                    </span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mt-1">
                            <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                            <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="removeGST" @click="removevalue()">X</button>
                        </b-col>
                    </b-row>
                   </div>
                    <div id="overlay">
                        <div class="loader"></div>
                    </div>

                    <footer class="column has-text-right">
                        <b-button variant="primary" size="md" type="submit" id="submitButton"
                        >Save</b-button
                        >&nbsp;
                        <b-button variant="primary" size="md" type="submit"
                        @click="$router.push('/vehicleMasternew')">Cancel</b-button>
                    </footer>
                </b-form>
            </b-col>
            <b-modal v-model="vehicleNameModal" title="Vehicle Name" size="md" hide-header hide-footer>
                <b-form-group>
                    <label for="vehicle name">Vehicle Name</label>&nbsp;<span style="color: red;">*</span>
                        <b-form-input
                            type="text"
                            name="vehicle name"
                            v-model="customer.vehiclename"
                            v-validate="'required|min:3|max:30'"
                            :class="{
                                input: true,
                                'is-invalid': errors.has('form-1.vehicle name'),
                            }"
                            placeholder="Enter Vehicle Name"
                        >
                        </b-form-input>
                        <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                                <i
                                class="fa fa-warning"
                                v-show="errors.has('vehicle name')"
                                ></i>
                            </span>
                            <span
                                style="width:240px"
                                v-show="errors.has('form-1.vehicle name')"
                                class="help text-danger"
                            >{{ errors.first("form-1.vehicle name") }}</span>
                        </b-input-group>
                </b-form-group>             
            </b-modal>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Router from "vue-router";
export default {
    data() {
        return {
            name: "regular",
            customer: {},
            alternatenumbermsg: "",
            user_id: 0,
            isIVR: "1",
            selected: "",
            cityData: [],
            adminData: [],
            userType: "",
            valueAdmin: [],
            optionsAdmin: [],
            fieldAdmin: { text: "name", value: "id" },
            sendadminid: [],
            warehouseData: [],
            warehouseAdmin: [],
            valueWHAdmin :[],
            fieldwhAdmin: { text: "name_wh", value: "id_wh" },
            mailitems :[],
            optionmailid :[],
            helper_data:[],
            transporterObj:{},
            transporterCompanyName:null,
            searchableField:true,
            textField:false,
            errors_GST:false,
            errors_showGST:{},
            removeGST:false,
            showverifybutton : false,
            driver_data :[],
            adminHub:null,
            optionHubid:[],
            hubList:[],

            vehicleNameOptions:[],
            vehicleTypeSizeOptions:[],
            fuelTypeOptions:[],
            vehicleNameModal:false,
            vehiclenametext:false,
            vehicletypesizetext:false,
            getfullname:null
        }
    },

    created: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.userType = userInfo.user_type;
        this.user_id = userInfo.sysusermasterid;
        this.displayAdmin();
        if (this.userType==2) {
            this.WiseWarehouseList()
        }
        this.EmailListing();
        this.getVehicleDetailsList();
        let firstname = userInfo.userfirstname ? userInfo.userfirstname : ''
    let lastname = userInfo.userlastname ? userInfo.userlastname : ''
     this.getfullname = firstname +" "+ lastname;
    },

    methods: {
        displayAdmin: function() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const Obj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
            };
            console.log("Obj", Obj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
            .then((result) => {
                if (result.body.returnmsg === "Successful") {
                    this.adminData = result.body.returnvalue;
                    for (let i = 0; i < this.adminData.length; i++) {
                    let admin = {
                        name: this.adminData[i].userfirstname + "" +
                        this.adminData[i].userlastname + " - " +
                        (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
                        id: this.adminData[i].sysusermasterid,
                    };
                    this.optionsAdmin.push(admin);
                    }
                } else {
                    this.adminData = result.body.returnvalue;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        getVehicleDetailsList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={

            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsList`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    var vehicleNameData=result.body.returnvalue[0].vehicle_name;
                    var vehicleTypeSizeData=result.body.returnvalue[0].vehicle_type;
                    var fuelTypeData=result.body.returnvalue[0].fuel_Type;                   
                    
                    for(let i=0;i<vehicleNameData.length;++i){
                        this.vehicleNameOptions.push({
                            key:vehicleNameData[i].id,
                            label:vehicleNameData[i].value
                        })
                        if(i==vehicleNameData.length-1){
                            this.vehicleNameOptions.push({
                                label:'Other'
                            })
                        }
                    }  
                    console.log("vehicle Name Options-->",this.vehicleNameOptions)              

                    for(let i=0;i<vehicleTypeSizeData.length;++i){
                        this.vehicleTypeSizeOptions.push({
                            key:vehicleTypeSizeData[i].id,
                            label:vehicleTypeSizeData[i].value
                        })
                        if(i==vehicleTypeSizeData.length-1){
                            this.vehicleTypeSizeOptions.push({
                                label:'Other'
                            })
                        }
                    }
                    console.log("vehicle Type Size Options-->",this.vehicleTypeSizeOptions) 

                    for(let i=0;i<fuelTypeData.length;++i){
                        this.fuelTypeOptions.push({
                            key:fuelTypeData[i].id,
                            label:fuelTypeData[i].value
                        })
                    }
                    console.log("fuel Type Options-->",this.fuelTypeOptions) 
                }
                else{
                    this.vehicleNameOptions=[];
                    this.vehicleTypeSizeOptions=[];
                    this.fuelTypeOptions=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        addVehicleName:function(){
            this.customer.vehiclenametext='';
            if(this.customer.vehiclename.label=='Other'){
                this.vehiclenametext=true;
            }
            else{
                this.vehiclenametext=false;
            }
        },

        addVehicleTypeSize:function(){
            this.customer.vehicletypesizetext='';
            if(this.customer.vehicletypesize.label=='Other'){
                this.vehicletypesizetext=true;
            }
            else{
                this.vehicletypesizetext=false;
            }
        },

        chkmobileVal() {
            var chkValidate = true;
            var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

            var mobilenumber = document.getElementById("addmobilenumber").value;
            if (
                mobilenumber.trim() === "0000000000" ||
                mobilenumber.trim().length < 10
            ) {
                chkValidate = false;
                return false;
            } else if (
                mobilenumber.trim() != "" &&
                !mobilenumber.trim().match(chknumb)
            ) {
                chkValidate = false;
                return false;
            }
            return (chkValidate = chkValidate);
        },

        selectAdmin: function() {
            var systemUserid = [];
            this.valueAdmin;
            this.valueAdmin.toString();
            // console.log(' this.valueAdmin.toString();', this.valueAdmin)
            this.WiseWarehouseList();
            // if(this.valueWHAdmin.length){
              this.adminWiseHubList()
            // }
           
        },

        WiseWarehouseList: function() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            if (this.userType==2) {
                this.valueAdmin.push(this.user_id)
            }
            this.sendadminid = this.valueAdmin.toString().split(",");

            if (this.valueAdmin.length>0) {
                const Obj = {
                    sysusermasterid:  this.sendadminid,
                };
                console.log("Obj", Obj);
                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAdminWiseWarehouseList`, Obj)
                .then((result) => {
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                        this.warehouseAdmin = [];
                        this.warehouseData = result.body.returnvalue;
                        for (let i = 0; i < this.warehouseData.length; i++) {
                        let whadmin = {
                            name_wh: this.warehouseData[i].city + ' - ' +
                            this.warehouseData[i].warehousename,
                            id_wh: this.warehouseData[i].warehouseid,
                        };
                        this.warehouseAdmin.push(whadmin);
                        }
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            } 
            else{
                this.warehouseData = [];
                this.warehouseAdmin = [];
                this.valueWHAdmin = [];
            }
        },

        selectWHAdmin: function() {
            var systemUserid = [];
            this.valueWHAdmin;
            this.valueWHAdmin.toString();
           
        },
 
        checkGSTlength(value){
            if (value.length>0) {
                this.showverifybutton=true;
                document.getElementById("submitButton").disabled = true; 
            }
            else{
                this.showverifybutton=false;
                this.customer.transporter_gstnumber='';
                this.errors_GST = false;
                this.errors_showGST= {};
                document.getElementById("submitButton").disabled = false;
                this.removeGST=false;
            }
        },

        verifyGSTNo(){
            document.getElementById("overlay").style.display = "block";
            const infoObj = {
                Gstin:this.customer.transporter_gstnumber.trim(),
            };
            console.log("infoObj",infoObj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
                console.log("result",result)
                document.getElementById("overlay").style.display = "none";
                if (result.body === "success") {
                document.getElementById("submitButton").disabled = false;
                this.showverifybutton=false;
                this.$fire({
                    text: 'Successful Verify',
                    type: "success",
                    timer: 30000,
                });
                this.errors_GST = false;
                this.errors_showGST.transporter_gstnumber=''
                this.removeGST=false;
                } else {
                this.errors_GST = true;
                this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
                this.removeGST=true;
                }
            }).catch((ex) => {
                console.log("error", ex);
            });
            // if (this.customer.transporter_gstnumber) {
            //     this.errors_GST = true;
            //     this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
            //     this.removeGST=true;
            //     return false;
            // }
            // else{
            //     this.showverifybutton=false;
            //     document.getElementById("submitButton").disabled = false;
            // }
        },

        removevalue(){
            this.showverifybutton=false;
            this.customer.transporter_gstnumber='';
            this.errors_GST = false;
            this.errors_showGST= {};
            document.getElementById("submitButton").disabled = false;
            this.removeGST=false;
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                this.addAgentInfo();
                }
            });
        },

        addAgentInfo: function() {
            var chkmobileVal = this.chkmobileVal();
            if (chkmobileVal) {
                document.getElementById("overlay").style.display = "block";
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
                console.log("YUUUUU", userInfo);

                if (this.userType == 1) {
                    if (this.valueAdmin.length > 0) {
                    var systemUserid = [];
                    systemUserid = this.valueAdmin.toString().split(",");
                }
                else{
                    this.$fire({
                    text: "Please Select Admin",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;
                }

                }
                if (this.valueWHAdmin.length > 0) {
                    var selctWarehouseid = [];
                    selctWarehouseid = this.valueWHAdmin.toString().split(",");
                }
                else{
                    this.$fire({
                    text: "Please Select City",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;
                }


                // var systemUserid = [];
                // systemUserid = this.valueAdmin.toString().split(",");
                var loginUserid = [];
                loginUserid = this.user_id.toString().split(",");

                if (this.customer.driveraltmobilenumber != this.customer.drivermobilenumber && this.customer.helpermobilenumber != this.customer.helperaltmobilenumber)
                {
                    var alternatenumber = this.customer.driveraltmobilenumber;
                    var helperalternatenumber = this.customer.helperaltmobilenumber;
                } else {
                    this.$fire({
                    text:
                        "Alternate_Mobile Number should be different from Mobile Number",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;
                }


                let validregex = /(([A-Z]){2}([0-9]){6})|(([A-Z]){2}([0-9]){2}([A-Z]){1}([0-9]){4})|(([A-Z]){2}([0-9]){2}([A-Z]){2}([0-9]){4})|(([A-Z]){3}([0-9]){4})|(([A-Z]){2}([0-9]){3}([A-Z]){1}([0-9]){4})|(([A-Z]){2}([0-9]){2}([A-Z]){3}([0-9]){4})|(([A-Z]{2}[0-9]{4}))/g;

                // var regex = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/; 


                let validvehicleno = []
                let crosscheck;
                // console.log("this.customer.vehicleno",this.customer.vehicleno)
                // console.log("RRRRRRRRRRRRRR", (this.customer.vehicleno).match(validregex));
                ///////////////return false;                
                if ((this.customer.vehicleno).match(validregex) !== null) {
                validvehicleno.push((this.customer.vehicleno).match(validregex));
                crosscheck = ((validvehicleno[0]).toString()).localeCompare(this.customer.vehicleno);
                }
                if (validvehicleno.length && crosscheck == 0){ 
                // alert("Successful") 
                }
                else{
                this.$fire({
                    text:"Please Enter Valid Vehicle Number",
                    type: "warning",
                    timer: 30000,
                });
                document.getElementById("overlay").style.display = "none";
                return false;
                }
                if(this.transporterCompanyName==null){
                    this.$fire({
                    text:"Please Select Transporter Company",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;  
                }
                if(userInfo.hub_id == null && userInfo.user_type=='2'){
                    this.$fire({
                    text:"Please Map Hub to Admin",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return false;
                }
                if(this.customer.drivercontractername == null || this.customer.contractormobilenumber == null || this.customer.contracteremail ==null){
                    this.$fire({
                    text:"Please Add Transporter Details From Transporter Master",
                    type: "warning",
                    timer: 30000,
                    });
                    document.getElementById("overlay").style.display = "none";
                    return; 
                }
                this.driver_data.push({
                    driverfirstname: this.customer.driverfirstname.trim(),
                    driverlastname: this.customer.driverlastname.trim(),
                    drivermobilenumber: this.customer.drivermobilenumber.trim(),
                    driveraltmobilenumber: this.customer.driveraltmobilenumber.trim(),
                    driving_license: this.customer.drivinglicense.trim(),
                    driver_license_photo:'',
                    driver_license_criteria:'',
                    driver_email:'',
                    driver_adhar_no:'',
                    driver_emergency_no:'',
                    driver_adhar_photo:'',
                    driver_language:[],
                    driver_qualification:[]
                });
                this.helper_data.push({
                        helperfirstname: this.customer.helperfirstname.trim(),
                        helperlastname: this.customer.helperlastname.trim(),
                        helpermobilenumber: this.customer.helpermobilenumber.trim(),
                        helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
                        helper_license_number:"",
                        helper_license_photo:"",
                        helper_license_criteria:"",
                        helper_email:"",
                        helper_adhar_no:"",
                        helper_adhar_photo:""
                    });
                console.log("this.helper_data",this.helper_data);
                    const agnetsave = {
                    driverfirstname: this.customer.driverfirstname.trim(),
                    driverlastname: this.customer.driverlastname.trim(),
                    drivermobilenumber: this.customer.drivermobilenumber.trim(),
                    driveraltmobilenumber: this.customer.driveraltmobilenumber.trim(),
                    password: this.customer.password.trim(),
                    vehicleno: this.customer.vehicleno.trim(),
                    vehiclename: this.vehiclenametext==false ? this.customer.vehiclename.key:this.customer.vehiclenametext.trim(),

                    lastmodifiedby: `${userInfo.sysemailid.trim()}`,
                    fueltype: this.customer.fueltype.key,
                    //vehicletype: this.customer.vehicletype.trim(),

                    vehicletypesize: this.vehicletypesizetext==false ? this.customer.vehicletypesize.key:this.customer.vehicletypesizetext.trim(),
                    vehicletype: this.customer.vehicletype.trim(),
                    // vehiclename: this.customer.vehiclename.trim(),
                    registration_no : this.customer.registration_no.trim(),
                    // vehiclemake: this.customer.vehiclemake.trim(),
                    vehicleweightcarrying: this.customer.vehicleweightcarrying.trim(),
                    vehiclephysicalweight: this.customer.vehiclephysicalweight.trim(),
                    vehicledimensionsweight : this.customer.vehicledimensionsweight.trim(),
                    driving_license: this.customer.drivinglicense.trim(),
                    helperfirstname: this.customer.helperfirstname.trim(),
                    helperlastname: this.customer.helperlastname.trim(),
                    helpermobilenumber: this.customer.helpermobilenumber.trim(),
                    helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
                    contracter_emailid: this.customer.contracteremail!=null || this.customer.contracteremail !=undefined || this.customer.contracteremail!="" ? this.customer.contracteremail.trim() : "",
                    // drivercontractername: this.customer.drivercontractername.trim(),
                     drivercontractername: this.customer.drivercontractername!=null || this.customer.drivercontractername !=undefined || this.customer.drivercontractername!=""?this.customer.drivercontractername.trim():"",
                     contractormobilenumber: this.customer.contractormobilenumber!=null || this.customer.contractormobilenumber !=undefined || this.customer.contractormobilenumber!="" ? this.customer.contractormobilenumber.trim():"",
                    sysusermasterid: this.userType == 1 ? systemUserid: loginUserid,
                    warehouseid : selctWarehouseid,
                    transporter_id:this.transporterObj.transporter_id?this.transporterObj.transporter_id:'',
                    helper_data:this.helper_data,
                    driver_data:this.driver_data,
                    transporter_company_name:this.searchableField==false?this.transporterCompanyName.trim():`${this.transporterCompanyName.label.trim()}`,
                    transporter_gstnumber:`${this.customer.transporter_gstnumber==null || this.customer.transporter_gstnumber==undefined || this.customer.transporter_gstnumber==''?'':this.customer.transporter_gstnumber.trim()}`,
                    hubid:userInfo.user_type=='2'?userInfo.hub_id:(this.adminHub?this.adminHub.key:""),
                    userfullname:this.getfullname
                    };
                    console.log("iffff", agnetsave);
                    // return false;

                this.$http
                .post(`${CONSTANTS.MIGRATION_API_URL}/addVehicleDetail`,agnetsave)
                .then((result) => {
                    console.log(result);
                    document.getElementById("overlay").style.display = "none";
                    if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                    this.customer = {};
                    this.$router.push("/vehicleMasternew");
                    // adhocVehicle
                    } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            }
        },

        EmailListing(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj = {
                 status : 'Approved'
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdList`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.mailitems  = result.body.returnvalue;
                console.log("mailitems",this.mailitems);
                var data = [];
    
                this.mailitems.forEach(function (srData) {
                    data.push({
                    key:srData.transporter_id,
                    label:srData.transporter_company_name
                    });
                });
                this.optionmailid = data;
                console.log( data)
                }
                else{
                  this.mailitems=[];
                  this.optionmailid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        },

        updateTextbox() {
            let transporterObj={};
            if(this.transporterCompanyName!=null){
                for(let i=0;i<this.mailitems.length;i++){
                if(this.transporterCompanyName.key===this.mailitems[i].transporter_id){
                    transporterObj={
                        transporter_id:this.mailitems[i].transporter_id,
                        transporter_name:this.mailitems[i].transporter_name,
                        transporter_emailid:this.mailitems[i].transporter_emailid,
                        transporter_mobilenumber:this.mailitems[i].transporter_mobilenumber,
                        //transporter_gstnumber:this.mailitems[i].transporter_gst_no
                        transporter_gstnumber:this.mailitems[i].transporter_gst_no == undefined || this.mailitems[i].transporter_gst_no == 'undefined' ? '' : this.mailitems[i].transporter_gst_no
                    }
                }
            }
            this.transporterObj=transporterObj;
            this.updateData(transporterObj);
            }
        },

        updateData(transporterObj){
            this.customer.contracteremail=transporterObj.transporter_emailid;
            this.customer.drivercontractername=transporterObj.transporter_name;
            this.customer.contractormobilenumber=transporterObj.transporter_mobilenumber;
            this.customer.transporter_gstnumber=transporterObj.transporter_gstnumber;
            
        },

        addemailid_fileds(){
            // alert("inn")
            this.searchableField =! this.searchableField;
            // document.getElementById('serchebledropemail').style.display='none';
            this.transporterCompanyName="";
            this.customer.contracteremail = "";
            this.customer.drivercontractername = "";
            this.customer.contractormobilenumber = "";
            this.customer.transporter_gstnumber = "";
            // this.textField=true
            // document.getElementById('textfieldemailid').style.display = 'block';
        },
        adminWiseHubList(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            let sysId = this.valueAdmin.toString().split(",");
            let obj = {
                sysusermasterid:sysId
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAdminHubListing`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                this.hubList  = result.body.returnvalue;
                // console.log("hubList",this.hubList);
                var data = [];
    
                this.hubList.forEach(function (srData) {
                    data.push({
                    key:srData.hubid,
                    label:srData.hubname
                    });
                });
                this.optionHubid = data;
                // console.log( data)
                }
                else{
                  this.hubList=[];
                  this.optionHubid = [];
                }

            }).catch(ex => {
              console.log('error', ex)
            })
        }
    },
}
</script>

<style>
.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
}
</style>
